import React from "react";
import {
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  required,
  BooleanInput,
} from "react-admin";
import VideoUpload from "../upload/FileUploader";
import { FormToolbar } from "../../common/FormToolbar";

export const PolicyTypeCreate = (props) => {
  let defaultValues = {
    
    isActive: true,
    code:"-",
    isNonTarrif:false,
    isNonPOS:false,
    isRenewalMail:false,
    isTPA:false
    
    
  };
  return (
    <Create title="Policy Type  Create" {...props} undoable={false} >
      <SimpleForm redirect="list" toolbar={<FormToolbar {...props} showDelete={false} />} variant="outlined"   initialValues={defaultValues}>
      
       <TextInput source="name"  fullWidth={true}  validate={[required()]}/>
       <ReferenceInput label="Policy Category " fullWidth={true} source="policyCategoryId" reference="policy-categories"  perPage={2000}>
            <SelectInput optionText="name"  />
        </ReferenceInput>

       <ReferenceInput label="Policy Department " fullWidth={true} source="policyDepartmentId" reference="policy-departments" perPage={2000}>
            <SelectInput optionText="name"  />
        </ReferenceInput>

        
        <BooleanInput source="isNonTarrif" validate={[required()]}  label="Is Non Tarrif" />
        <BooleanInput source="isNonPOS" validate={[required()]}  label="Is Non Pos" />
        <BooleanInput source="isTPA" validate={[required()]}  label="Is TPA" />
        <BooleanInput source="isRenewalMail" validate={[required()]}  label="is Renewal Mail" />
        <BooleanInput source="isActive" validate={[required()]}  label="Active" initialValue={true}/>
      </SimpleForm>
    </Create>
  );
};
